import _orderBy from 'lodash/orderBy';
import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { actions } from '../../../telephony/actions/telephony';
import CustomDropDownButton from '../components/OutboundNumberSelector';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    meta: state.telephony.meta,
    ui: state.telephony.ui,
    selectedFromNumber: state.telephony.selectedFromNumber,
    isOpen: state.telephony.isOpen,
    isReady: state.telephony.isReady,
    isMicrophoneBlocked: state.telephony.isMicrophoneBlocked,
    users: state.telephony.users,
    dynamicTelephoneNumbersArray: _orderBy(
      state.telephony.dynamicTelephoneNumbersArray,
      ['e164_format'],
    ),
    staticTelephoneNumbersArray: state.telephony.staticTelephoneNumbersArray,
    nextPage: state.telephony.nextPage,
    previousPage: state.telephony.previousPage,
    agentDefaultNumber: state.settings.profile.profile.default_outbound_number,
    toggleOwnNumbersView: ownProps.toggleOwnNumbersView,
    isOwnNumbersViewOpen: ownProps.isOwnNumbersViewOpen,
    fromNumberFormat: ownProps.fromNumberFormat,
    fromNumberCountryCode: ownProps.fromNumberCountryCode,
    returnFromNumberFormat: ownProps.returnFromNumberFormat,
    setFromNumberCountryCode: ownProps.setFromNumberCountryCode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    changeFromNumber: (payload: any) =>
      dispatch(actions.telephonyChangeFromNumber(payload)),
    telephonyGetQueryNumbers: bindActionToPromise(
      dispatch,
      actions.telephonyGetQueryNumbers,
    ),
    telephonyGetAllOwnNumbers: bindActionToPromise(
      dispatch,
      actions.telephonyGetAllOwnNumbers,
    ),
    telephonyGetDefaultNumber: bindActionToPromise(
      dispatch,
      actions.telephonyGetDefaultNumber,
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomDropDownButton);
